import { GlobalState } from '@common/Checkout/Checkout/types';
import { GlobalReducer } from '@common/Checkout/Checkout/types/reducers';
import { SET_IS_REQUEST_PENDING } from '../actions/constants';

const initialState: GlobalState = {
    isRequestPending: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: GlobalReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case SET_IS_REQUEST_PENDING: {
            const { payload } = action;

            return {
                ...state,
                isRequestPending: payload,
            };
        }

        default:
            return state;
    }
};

export default reducer;
